
import CompanyHelper from '@/bussiness/CompanyHelper';
import CommonLoading from '@/component/CommonLoading';
import IC_PERSONAL from '@/assets/common/ic_personal.svg?react';
import ArrowRightIcon from "@/assets/common/ic_arrow_right.svg?react";
import { RuningInLink } from '@/constants';
import userInfoStore from "@/store/user.store";
import { CompanyInfo } from '@/types/company';
import { isWindows } from '@/utils/platform';
import { useEffect, useState } from 'react';
import { maxMobileWidth } from '@/constants/share';
import { useNavigate } from 'react-router-dom';
import { setMainSize } from '@/utils/window';

interface IChoseCompanyProps {
  disableAutoJumpHome?: boolean;
}

export default function ChoseCompany({ disableAutoJumpHome }: IChoseCompanyProps) {
  const navigate = useNavigate();
  const displayMobile = userInfoStore((state) => state.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2"));

  const [isLoading, setIsLoading] = useState(true);
  const [list, setList] = useState<CompanyInfo[]>([]);
  const [hoverIndex, setHoverIndex] = useState<number>(-1);

  useEffect(() => {
    CompanyHelper.getCompanyInfo().then((res) => {
      setList(res.list);
      setIsLoading(false);
      if (res.list.length === 1 && !disableAutoJumpHome) {
        if (res.list[0].identityType == 0) {
          jumpHome();
        } else {
          CompanyHelper.choiceCompany(res.list[0].identityId, jumpHome);
        }
      }
    }).catch(e => {
      console.log(e);
      setIsLoading(false);
    });
  }, [disableAutoJumpHome]);


  const isMobile = document.documentElement.clientWidth <= maxMobileWidth;
  const isWindow = isWindows();

  const jumpHome = () => {
    setMainSize();
    navigate("/home", { replace: true });
  }

  const buildCompany = (model: CompanyInfo, index: number) => {
    const isPersonal = model.identityType == 0;
    const name = model.identityType == 0 ? '个人账户' : model.companyName.substring(0, 2);
    return (
      <div key={model.identityId} className={`flex p-2.5 items-center ${hoverIndex == index ? "bg-#F4F6F9" : ""} h-14 rd-1 cursor-pointer`}
        onClick={() => {
          CompanyHelper.choiceCompany(model.identityId, jumpHome);
        }}
        onMouseEnter={() => {
          if (!RuningInLink && isMobile) return;
          setHoverIndex(index);
        }}
        onMouseLeave={() => {
          if (!RuningInLink && isMobile) return;
          setHoverIndex(-1);
        }}>
        {
          model.logo ?
            <img src={model.logo} className="size-10 rd-2" /> :
            <div className="w-10 h-10 rd-2 bg-img flex justify-center items-center">
              {isPersonal ?
                <IC_PERSONAL className="w-4.5 h-4.5" /> :
                <span className="text-size-3.5 text-white font-600">{name}</span>}
            </div>
        }
        <span className="ml-4 text-size-3.5 flex-1 text-#30343C whitespace-nowrap overflow-hidden text-ellipsis">{isPersonal ? '个人账户' : model.companyName}</span>
        {
          hoverIndex !== index ?
            <ArrowRightIcon className="size-4" /> :
            <div className="text-size-3 text-#4981F2">进入</div>
        }
      </div>
    );
  }

  return (
    <div className={`login h-full w-full ${!RuningInLink && isMobile ? 'bg-#ECEEF3' : 'bg-white'} relative`}>
      <div className={`px-4 flex flex-col ${isMobile ? '' : 'absolute left-1/2 -translate-x-1/2'} ${!RuningInLink && !isMobile ? 'w-100' : ''}`}>
        <span className={`${RuningInLink ? (isWindow ? "mt-16" : "mt-20") : (isMobile ? "mt-9" : "mt-30")} text-#30343C tex-size-5 font-600 mx-2`}>你可进入以下组织</span>
        <span className='text-#626773 text-size-3.5 lh-5.5 mt-2 mx-2'>{displayMobile}已在以下企业/组织绑定了账号，你可进入以下任一企业/组织</span>
        <div className={`flex-1 flex flex-col`}>
          {isLoading ?
            <CommonLoading className="size-6 self-center mt-10" />
            :
            <div className={`mt-6 ${isMobile ? 'bg-white rd-3' : 'w-92'}`}>
              {list.map((item, idx) => buildCompany(item, idx))}
            </div>}
        </div>
      </div>
    </div>
  );
}